import { render, staticRenderFns } from "./IsLocked.vue?vue&type=template&id=f48c4db8"
import script from "./IsLocked.vue?vue&type=script&lang=js"
export * from "./IsLocked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports